import { getWallets, IdentifierString } from '@iota/wallet-standard';

export const getIotaWalletById = (
  walletId: string,
  chainId: IdentifierString,
) => {
  return getWallets()
    .get()
    .find(wallet => {
      return (
        (wallet?.id === walletId || wallet?.name === walletId) &&
        wallet?.chains.find(chain => chain === chainId)
      );
    });
};
